module.exports = __webpack_public_path__ + "static/media/MarkPro-Medium.05732167.woff";